import { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Resizer from "react-image-file-resizer";
import Loading from "../../screens/common/loading";

function AddMedical(props) {
  var cid = props.match.params.cid;

  let history = useHistory();

  const [dob, setDob] = useState("");
  const [cname, setCname] = useState("");
  const [cnum, setCnum] = useState("");
  const [cadd, setCadd] = useState("");
  const [passport, setPassport] = useState("");
  const [nid, setNid] = useState("");
  const [base, setBase] = useState("");
  const [gross, setGross] = useState("");
  const [idate, setIdate] = useState("");
  const [vat, setVat] = useState("");
  const [profit, setProfit] = useState("");
  const [vendor, setVendor] = useState("");
  const [pval, setPval] = useState("");
  const [visa, setVisa] = useState("");
  const [cphoto, setCphoto] = useState("");

  const [cserial, setCserial] = useState("");
  const [edate, setEdate] = useState("");
  const [ddate, setDdate] = useState("");

  const [aid, setAid] = useState(0);
  const [agents, setAgents] = useState([]);

  const [note, setNote] = useState("");
  const [load, setLoad] = useState(false);

  const [vendors, setVendors] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [medical, setMedical] = useState("");
  const [cof, setCof] = useState("");

  //MEDICAL

  const [ctype, setCtype] = useState("");

  const [show, setShow] = useState(false);

  const [gpnr, setGpnr] = useState("");

  function handleSubmit(e) {
    e.preventDefault();

    setLoad(true);
    const data = new FormData();

    data.append("cid", cid);
    data.append("cname", cname);
    data.append("cnum", cnum);
    data.append("cadd", cadd);

    data.append("dob", dob);

    data.append("cserial", cserial);
    data.append("passport", passport);

    data.append("nid", nid);
    data.append("pval", pval);
    data.append("user", cphoto);

    data.append("visa", visa);
    data.append("ddate", ddate);
    data.append("idate", idate);
    data.append("edate", edate);

    data.append("base", base);
    data.append("gross", gross);
    data.append("vat", vat);
    data.append("profit", profit);

    data.append("note", note);
    data.append("gpnr", gpnr);
    data.append("pedate", pval);
    data.append("vendor", vendor);
    data.append("ctype", ctype);
    data.append("aid", aid);
    data.append("medical", medical);
    data.append("cof", cof);
    data.append("token", localStorage.getItem("token"));

    axios
      .post(
        "https://concorde-api.flydocx.com/" +
          process.env.REACT_APP_URL +
          "/admedical",
        data
      )
      .then((res) => {
        setLoad(false);
        if (res.data.message == null) {
          history.push("/customer/medical");
        }
      })
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    console.log("hey");
    axios
      .post(
        "https://concorde-api.flydocx.com/" +
          process.env.REACT_APP_URL +
          "/fetchalltypevendor"
      )
      .then((res) => setVendors(res.data.message))
      .catch((err) => console.log(err));

    axios
      .post(
        "https://concorde-api.flydocx.com/" +
          process.env.REACT_APP_URL +
          "/fetchstaff"
      )
      .then((res) => {
        console.log(res.data.message);
        setStaffs(res.data.message);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .post(
        "https://concorde-api.flydocx.com/" +
          process.env.REACT_APP_URL +
          "/fetchagent"
      )
      .then((res) => setAgents(res.data.message))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .post(
        "https://concorde-api.flydocx.com/" +
          process.env.REACT_APP_URL +
          "/fetchcustomerbyid",
        {
          cid: cid,
        }
      )
      .then((res) => {
        setCname(res.data.suser[0].cname);
        setCadd(res.data.suser[0].cadd);
        setCnum(res.data.suser[0].cnum);
        setDob(res.data.suser[0].dob);
        setNid(res.data.suser[0].nid);
        setPassport(res.data.suser[0].passport);
        setPval(res.data.suser[0].pval);
        setCserial(res.data.suser[0].serial);
        setCphoto(res.data.suser[0].cphoto);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <ToastContainer />

      <div class="container border mb-4 bg-light pt-3">
        <div class="pb-3">
          <Loading load={load} />

          <form onSubmit={handleSubmit} id="create-course-form">
            <div>
              <div class="form-group row py-1">
                <label for="" class="col-lg-2 col-12 col-form-label infotext">
                  Customer Type
                </label>

                <div class="col-lg-4 col-12 mt-2">
                  <div class="form-check form-check-inline">
                    <input
                      name="ctype"
                      id="fit"
                      type="radio"
                      class="form-check-input"
                      value="regular"
                      required="required"
                      checked={ctype == "regular" ? true : false}
                      onChange={(e) => {
                        setCtype(e.target.value);
                        setShow(false);
                      }}
                    />
                    <label for="_0" class="form-check-label infotext mr-2">
                      Regular
                    </label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input
                      name="ctype"
                      id="fit"
                      type="radio"
                      class="form-check-input"
                      value="agent"
                      required="required"
                      checked={ctype == "agent" ? true : false}
                      onChange={(e) => {
                        setCtype(e.target.value);
                        setShow(true);
                      }}
                    />
                    <label for="_0" class="form-check-label infotext mr-2">
                      From Agent
                    </label>
                  </div>
                </div>
              </div>

              {ctype == "agent" ? (
                <div class="form-group row py-1">
                  <label for="" class="col-lg-2 col-12 col-form-label infotext">
                    Agent Name
                  </label>
                  <div class="col-lg-4 col-12">
                    <div class="input-group">
                      {ctype == "agent" ? (
                        <select
                          class="form-control"
                          value={aid}
                          onChange={(e) => setAid(e.target.value)}
                        >
                          <option>Choose Agent</option>
                          {staffs.map((item) => (
                            <option value={item.id}>{item.sname}</option>
                          ))}
                        </select>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}

              <div class="form-group row py-1">
                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  Visa No
                </label>
                <div class="col-lg-4 col-6">
                  <input
                    id="textarea"
                    name="text"
                    type="text"
                    class="form-control"
                    required=""
                    value={visa}
                    onChange={(e) => setVisa(e.target.value)}
                  ></input>
                </div>

                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  Medical Center Name
                </label>
                <div class="col-lg-4 col-12">
                  <input
                    class="form-control"
                    value={medical}
                    onChange={(e) => setMedical(e.target.value)}
                  ></input>
                </div>
              </div>
              <div class="form-group row py-1">
                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  Issue Date
                </label>
                <div class="col-lg-4 col-12">
                  <input
                    id="textarea"
                    name="text"
                    type="date"
                    class="form-control"
                    required=""
                    value={idate}
                    onChange={(e) => setIdate(e.target.value)}
                  ></input>
                </div>

                <label
                  for="textarea"
                  class="col-lg-2 col-12 marginTop infotext col-form-label"
                >
                  Delivery Date
                </label>
                <div class="col-lg-4 col-12">
                  <input
                    id="textarea"
                    name="text"
                    type="date"
                    class="form-control"
                    required=""
                    value={ddate}
                    onChange={(e) => setDdate(e.target.value)}
                  ></input>
                </div>
              </div>

              <div class="form-group row py-1">
                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  Expiry date
                </label>
                <div class="col-lg-4 col-6">
                  <input
                    id="textarea"
                    name="text"
                    type="date"
                    class="form-control"
                    required=""
                    value={edate}
                    onChange={(e) => setEdate(e.target.value)}
                  ></input>
                </div>

                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  Care Of
                </label>
                <div class="col-lg-4 col-6">
                  <select
                    class="form-control"
                    value={cof}
                    onChange={(e) => setCof(e.target.value)}
                  >
                    <option>Choose Staff</option>
                    {staffs.map((item) => (
                      <option value={item.id}>{item.sname}</option>
                    ))}
                  </select>
                </div>
              </div>

              <i
                class="fa fa-clock-o"
                id="clbtn2"
                data-toggle="modal"
                data-target="#exampleModal2"
                style={{ margin: 2, fontSize: 20, display: "none" }}
              ></i>
              <i
                class="fa fa-clock-o"
                id="clbtn3"
                data-toggle="modal"
                data-target="#exampleModal"
                style={{ margin: 2, fontSize: 20, display: "none" }}
              ></i>

              <div class="form-group row py-1">
                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  Additional Note
                </label>
                <div class="col-lg-10 col-12">
                  <textarea
                    id="textarea"
                    name="textarea"
                    cols="40"
                    rows="2"
                    class="form-control"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  ></textarea>
                </div>
              </div>

              <hr />

              <div class="form-group row py-1">
                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  Vendor
                </label>
                <div class="col-lg-4 col-12">
                  <select
                    id="inputState"
                    class="form-select form-control"
                    value={vendor}
                    onChange={(e) => setVendor(e.target.value)}
                  >
                    <option class="form-control" selected>
                      Choose Vendor
                    </option>

                    {vendors.map((item) => {
                      if (item.type == "medical") {
                        return <option value={item.id}>{item.vname}</option>;
                      }

                      if (item.type == "all") {
                        return <option value={item.id}>{item.vname}</option>;
                      }
                    })}
                  </select>
                </div>

                <label
                  for="textarea"
                  class="col-lg-2 col-12  infotext col-form-label"
                >
                  Buying Price
                </label>
                <div class="col-lg-4 col-12">
                  <input
                    id="textarea"
                    name="text"
                    type="number"
                    class="form-control"
                    required="required"
                    value={base}
                    onChange={(e) => setBase(e.target.value)}
                  ></input>
                </div>
              </div>

              <div class="form-group row py-1">
                <label
                  for="textarea"
                  class="col-lg-2 col-12 marginTop infotext col-form-label"
                >
                  {ctype == "agent" ? "Agent Fare" : "Selling Price"}
                </label>
                <div class="col-lg-2 col-12">
                  <input
                    id="textarea"
                    name="text"
                    type="number"
                    class="form-control"
                    required="required"
                    value={gross}
                    onChange={(e) => setGross(e.target.value)}
                  ></input>
                </div>

                <label
                  for="textarea"
                  class="col-lg-2 col-12 infotext col-form-label"
                >
                  VAT & AIT
                </label>
                <div class="col-lg-2 col-6">
                  <input
                    id="textarea"
                    name="text"
                    type="number"
                    class="form-control"
                    required=""
                    placeholder="Ex. 0.03"
                    value={vat}
                    onChange={(e) => {
                      var p =
                        Number(gross) - (Number(base) + Number(e.target.value));
                      setVat(e.target.value);
                      setProfit(p);
                    }}
                  ></input>
                </div>

                <label
                  for="textarea"
                  class="col-lg-2 col-12 marginTop infotext col-form-label"
                >
                  Profit
                </label>
                <div class="col-lg-2 col-6">
                  <input
                    id="textarea"
                    name="text"
                    type="text"
                    class="form-control"
                    required=""
                    disabled
                    value={profit}
                    onChange={(e) => setProfit(e.target.value)}
                  ></input>
                </div>

                <br />
              </div>
            </div>

            <div class="form-group row py-2">
              <div class="col-lg-2"></div>
              <div class="col-lg-10 col-12">
                <button class="w-100 btn btn-primary">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default withRouter(AddMedical);
